import { promiseAction } from 'utils/store';

export const LANGUAGES_ACTION_TYPES = {
  LOAD_PLAIN_LANGUAGES: 'languages/LOAD_PLAIN_LANGUAGES',
  CREATE_LANGUAGE: 'languages/CREATE_LANGUAGE',
  EDIT_LANGUAGE: 'languages/EDIT_LANGUAGE',
  DELETE_LANGUAGE: 'languages/DELETE_LANGUAGE',
  LOAD_TRANSLATIONS: 'languages/LOAD_TRANSLATIONS',
  ADD_TRANSLATIONS: 'languages/ADD_TRANSLATIONS',
  EDIT_TRANSLATIONS: 'languages/EDIT_TRANSLATIONS',
  CLEAR_TRANSLATIONS: 'languages/CLEAR_TRANSLATIONS',
  IMPORT_TRANSLATIONS: 'languages/IMPORT_TRANSLATIONS',
  GET_IMPORT_TRANSLATIONS_STATUS: 'languages/GET_IMPORT_TRANSLATIONS_STATUS',
};

export function loadPlainLanguages() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.LOAD_PLAIN_LANGUAGES,
        resolve,
        reject,
      });
    });
  };
}

export function createLanguage(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.CREATE_LANGUAGE,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function editLanguage(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.EDIT_LANGUAGE,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function deleteLanguage(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.DELETE_LANGUAGE,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function loadTranslations(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.LOAD_TRANSLATIONS,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function editTranslations(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.EDIT_TRANSLATIONS,
        payload,
        resolve,
        reject,
      });
    });
  };
}
export const addTranslations = promiseAction(LANGUAGES_ACTION_TYPES.ADD_TRANSLATIONS);

export function clearTranslations(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: LANGUAGES_ACTION_TYPES.CLEAR_TRANSLATIONS,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export const importTranslations = promiseAction(LANGUAGES_ACTION_TYPES.IMPORT_TRANSLATIONS)
export const getImportTranslationsStatus = promiseAction(LANGUAGES_ACTION_TYPES.GET_IMPORT_TRANSLATIONS_STATUS)